import { create } from "zustand"

const STORAGE_KEY = "sadeo_auth"

interface AuthState {
    token: string | null
    sessionType: "WAITER" | "ADMIN" | null
    korisnikId: number | null
    ime: string
    prezime: string
    companyId: number | null
    companyName: string
    poslovnaJedinicaId: number | null
    kasaId: number | null
    sessionPrinterId: number | null
    prava: { mozeStorno: boolean; mozeNaplacivati: boolean; mozePopust: boolean }
    setWaiterSession: (data: any) => void
    setAdminSession: (data: any) => void
    setSessionPrinter: (kasaId: number) => void
    clear: () => void
}

const DEFAULT_STATE = {
    token: null,
    sessionType: null,
    korisnikId: null,
    ime: "",
    prezime: "",
    companyId: null,
    companyName: "",
    poslovnaJedinicaId: null,
    kasaId: null,
    sessionPrinterId: null,
    prava: { mozeStorno: false, mozeNaplacivati: false, mozePopust: false }
}

function loadInitialAuth() {
    if (typeof window === "undefined") return DEFAULT_STATE
    try {
        const stored = localStorage.getItem(STORAGE_KEY)
        if (stored) {
            const data = JSON.parse(stored)
            return {
                token: data.token ?? null,
                sessionType: data.sessionType ?? null,
                korisnikId: data.korisnikId ?? null,
                ime: data.ime ?? "",
                prezime: data.prezime ?? "",
                companyId: data.companyId ?? null,
                companyName: data.companyName ?? "",
                poslovnaJedinicaId: data.poslovnaJedinicaId ?? null,
                kasaId: data.kasaId ?? null,
                sessionPrinterId: data.sessionPrinterId ?? null,
                prava: data.prava ?? DEFAULT_STATE.prava
            }
        }
    } catch {
        localStorage.removeItem(STORAGE_KEY)
    }
    return DEFAULT_STATE
}

function saveAuth(state: any) {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify({
            token: state.token,
            sessionType: state.sessionType,
            korisnikId: state.korisnikId,
            ime: state.ime,
            prezime: state.prezime,
            companyId: state.companyId,
            companyName: state.companyName,
            poslovnaJedinicaId: state.poslovnaJedinicaId,
            kasaId: state.kasaId,
            sessionPrinterId: state.sessionPrinterId,
            prava: state.prava
        }))
    } catch { }
}

export const useAuthStore = create<AuthState>((set, get) => ({
    ...loadInitialAuth(),
    setWaiterSession: (data) => {
        const next = {
            token: data.token,
            sessionType: "WAITER" as const,
            korisnikId: data.korisnikId,
            ime: data.ime,
            prezime: data.prezime,
            companyId: data.companyId,
            companyName: data.companyName,
            poslovnaJedinicaId: data.poslovnaJedinicaId ?? null,
            kasaId: data.kasaId ?? null,
            sessionPrinterId: data.sessionPrinterId ?? null,
            prava: data.prava
        }
        set(next)
        saveAuth({ ...get(), ...next })
    },
    setAdminSession: (data) => {
        const next = {
            token: data.token,
            sessionType: "ADMIN" as const,
            korisnikId: data.korisnikId,
            ime: data.ime,
            prezime: data.prezime
        }
        set(next)
        saveAuth({ ...get(), ...next })
    },
    setSessionPrinter: (kasaId) => {
        set({ sessionPrinterId: kasaId })
        saveAuth({ ...get(), sessionPrinterId: kasaId })
    },
    clear: () => {
        localStorage.removeItem(STORAGE_KEY)
        sessionStorage.removeItem("sadeo-cart")
        set(DEFAULT_STATE)
    }
}))